/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserReward } from '../../models/user-reward';

export interface UpdateLoyaltyUserReward$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
  rewardId: string;
      body: UserReward
}

export function updateLoyaltyUserReward(http: HttpClient, rootUrl: string, params: UpdateLoyaltyUserReward$Params, context?: HttpContext): Observable<StrictHttpResponse<UserReward>> {
  const rb = new RequestBuilder(rootUrl, updateLoyaltyUserReward.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
    rb.path('rewardId', params.rewardId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserReward>;
    })
  );
}

updateLoyaltyUserReward.PATH = '/loyalty/users/{userId}/rewards/{rewardId}';
